/*eslint no-undef: "off"*/

import React, { useEffect } from "react";

const VTO = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  const sku = searchParams.get("sku");
  let config = searchParams.get("config");

  useEffect(() => {
    loadSDK();
  });

  const loadSDK = () => {
    const existingScript = document.getElementById('vtoSDK');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://assets.artlabs.ai/js/experience/latest/artlabs-experience.umd.js';
      script.id = 'vtoSDK';

      script.onload = activateVTO;
      document.head.appendChild(script);
    }
  };

  function activateVTO() {
    // parse config
    if (config) {
      try {
        config = JSON.parse(config);
      } catch (error) { }
    }

    // init sdk 
    ArtlabsExperience.init({ token, config });

    // start experience
    ArtlabsExperience.startVTO(sku);

    // core events - mapped to new event names
    ArtlabsExperience.addEventListener('stop-vto', () => {
      if (window.webkit && window.webkit.messageHandlers &&
        window.webkit.messageHandlers["close-event"]) {
        window.webkit.messageHandlers["close-event"].postMessage(null);
      }

      if (window.AndroidInterface) {
        window.AndroidInterface.onEvent('close-event');
      }
    });

    // custom events - check if this event exists in new SDK
    ArtlabsExperience.addEventListener('vto-banner-click', (e) => {
      if (window.webkit && window.webkit.messageHandlers &&
        window.webkit.messageHandlers["add-to-cart"]) {
        window.webkit.messageHandlers["add-to-cart"].postMessage(e.detail);
      }

      if (window.AndroidInterface) {
        window.AndroidInterface.onEvent('add-to-cart', e.detail);
      }
    });
  }

  return (
    <div></div>
  );
};

export default VTO;
